import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/category/latest-address', label: '最新地址' },
    { to: '/category/search-tips', label: '搜索技巧' },
    { to: '/category/usage-tutorial', label: '使用教程' },
    { to: '/category/mirror-sites', label: '镜像站点' },
    { to: '/category/faq', label: '常见问题' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 shrink-0"
          >
            <span
              className={`text-xl font-heading font-bold transition-colors duration-300 ${
                scrolled || !isHome ? 'text-foreground-900' : 'text-white'
              }`}
            >
              JavBus
            </span>
            <span
              className={`hidden sm:inline text-xs font-label px-2 py-0.5 rounded-full transition-colors duration-300 ${
                scrolled || !isHome
                  ? 'bg-primary-100 text-primary-700'
                  : 'bg-white/20 text-white'
              }`}
            >
              使用指南
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`whitespace-nowrap px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  scrolled || !isHome
                    ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <Link
              to="/about"
              className={`whitespace-nowrap hidden md:inline-flex items-center px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                scrolled || !isHome
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-white/20 text-white hover:bg-white/30 backdrop-blur-sm'
              }`}
            >
              关于我们
            </Link>

            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className={`md:hidden w-9 h-9 flex items-center justify-center rounded-md transition-colors ${
                scrolled || !isHome
                  ? 'text-foreground-700 hover:bg-background-200'
                  : 'text-white hover:bg-white/10'
              }`}
              aria-label="菜单"
            >
              <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 animate-fade-in">
          <div className="px-4 py-3 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="block px-3 py-2.5 rounded-md text-sm font-medium text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-colors"
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="block px-3 py-2.5 rounded-md text-sm font-medium text-primary-600 hover:bg-primary-50 transition-colors"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}